/**
 * @forgedas/shared-core — entry point.
 *
 * Logic shared by the React web app (./frontend) and the Electron desktop
 * shell (packages/desktop). Per Step 3 of
 * Forge_iDAS_Desktop_Developer_Instructions.docx, components must NEVER call
 * Electron APIs directly; everything that needs the host OS goes through the
 * PlatformBridge.
 */

export * from './platform/PlatformBridge.js';
export * from './platform/WebPlatformBridge.js';
export * from './platform/DesktopPlatformBridge.js';
export * from './storage/TokenStore.js';
export * from './storage/DesktopTokenStore.js';
export * from './api/createApiClient.js';
export * from './api/types.js';
